import BaseChange from "./BaseChange"

export default class StartedChange extends BaseChange {
  constructor(message) {
    super()
    this.type = "started"
    this.setMessage(message)
  }
}
